import { useQuery } from "@tanstack/react-query";
import { getReportsAnalyticsUsers } from "../../API/ProtectedAuth";
import { handleApiError } from "../../Utils/errorHandler";

export default function useUsersAnalytics(options = {}) {
  const { period = "30d", include_trends = true } = options;

  const queryKey = ["usersAnalytics", { period, include_trends }];

  const { data, error, isLoading, refetch } = useQuery({
    queryKey,
    queryFn: async () => {
      try {
        const res = await getReportsAnalyticsUsers({ period, include_trends });
        return res;
      } catch (err) {
        handleApiError(err);
        throw err;
      }
    },
    staleTime: 1000 * 60 * 30, 
    cacheTime: 1000 * 60 * 60 * 12,
    refetchOnWindowFocus: false,
  });

  const usersAnalytics = data?.data ?? null;
  const generatedAt = data?.meta?.generated_at ? new Date(data.meta.generated_at) : null;

  return {
    usersAnalytics,
    generatedAt,
    error,
    isLoading,
    reload: refetch,
    period,
  };
}






































































